import React, { useCallback, useContext, useEffect, useState } from 'react';
import FooterStepper from '../../Components/Stepper/FooterStepper';
import { CircularProgress, makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { Step, StepperProvider } from '../../Contexts/StepperContext';
import Stepper from '../../Components/Stepper/Stepper';
import {
  FORM_ID,
  PREPAID_METER_RECHARGE_STEPS,
  PrepaidMeterRechargeStep
} from './PrepaidMeter_enums';
import ReadCardStep from './Steps/ReadCardStep';
import RechargeCalculationStep from './Steps/RechargeCalculationStep';
import CardDataStep from './Steps/CardDataStep';
import { UserContext } from '../../Contexts/UserContext';
import { history } from '../../Routes/history';
import _get from 'lodash/get';
import { ROUTE_NAMES } from '../../Routes/Routes';
import { GetRequestAPI } from '../../API/Requests/requestsAPI';
import WriteCardStep from './Steps/WriteCardStep';
import { requestStatus } from '../Requests/Utils/enums';
import { AlertsDispatchContext } from '../../Contexts/AlertsContext';
import { ALERT_TYPE } from '../../Components/Alerts/alert_enums';

const PrepaidMeter = props => {
  const { requestId: receivedRequestId } = props.match.params;

  const currentUser = useContext(UserContext);
  const classes = useStyles();

  const [nextButtonText, setNextButtonText] = useState('Siguiente');
  const [currentStep, setCurrentStep] = useState(0);
  const [goBack, setGoBack] = useState({});
  const [canSubmit, setCanSubmit] = useState(false);
  const authToken = _get(currentUser, 'token', null);
  const [requestId, setRequestId] = useState();
  const [loading, setLoading] = useState(true);

  const setAlert = useContext(AlertsDispatchContext);

  const redirectWithCoupon = useCallback(
    (coupon, meterSerial, rechargeUnits) => {
      history.push(ROUTE_NAMES.payments, {
        currentStep: 1,
        type: coupon.type,
        meterRecharge: true,
        payment: [coupon],
        productAdditionalData: {
          meterSerial,
          rechargeUnits,
          requestId
        }
      });
    },
    [requestId]
  );

  const fetchRechargeInfo = useCallback(
    async reqId => {
      if (!reqId) {
        setLoading(false);
        return;
      }

      const { success, data } = await GetRequestAPI(authToken, reqId);
      if (!success) {
        setLoading(false);
        return;
      }

      if (data.data.data.request.status === requestStatus.inProcess) {
        setRequestId(reqId);
      } else {
        setAlert({
          type: ALERT_TYPE.ERROR,
          message: 'Tu solicitud ya fue atendida'
        });
      }
      setLoading(false);
    },
    [authToken, setLoading, setRequestId]
  );

  useEffect(() => {
    fetchRechargeInfo(receivedRequestId);
  }, [fetchRechargeInfo, receivedRequestId]);

  const renderStepper = () => {
    return (
      <StepperProvider
        initialStepIndex={
          receivedRequestId && requestId
            ? PrepaidMeterRechargeStep.RechargeCard
            : 0
        }
      >
        <Step>
          <ReadCardStep
            setNextButtonText={setNextButtonText}
            setCurrentStep={setCurrentStep}
            setGoBack={setGoBack}
          />
        </Step>
        <Step>
          <CardDataStep
            formId={FORM_ID}
            setNextButtonText={setNextButtonText}
            setCurrentStep={setCurrentStep}
            setGoBack={setGoBack}
            authToken={authToken}
            setCanSubmit={setCanSubmit}
            setRequestId={setRequestId}
          />
        </Step>
        <Step>
          <RechargeCalculationStep
            formId={FORM_ID}
            setNextButtonText={setNextButtonText}
            setCurrentStep={setCurrentStep}
            setGoBack={setGoBack}
            setCanSubmit={setCanSubmit}
            requestId={requestId}
            setRequestId={setRequestId}
            authToken={authToken}
            redirectWithCoupon={redirectWithCoupon}
          />
        </Step>
        <Step>
          <WriteCardStep
            setCurrentStep={setCurrentStep}
            setNextButtonText={setNextButtonText}
            setGoBack={setGoBack}
            authToken={authToken}
            requestId={requestId}
            formId={FORM_ID}
            setCanSubmit={setCanSubmit}
          />
        </Step>
      </StepperProvider>
    );
  };

  return (
    <div className={clsx(classes.root)}>
      <div className={clsx(classes.centerContent, classes.contentContainer)}>
        <div className={clsx(classes.centerContent, classes.stepperContainer)}>
          <Stepper
            steps={PREPAID_METER_RECHARGE_STEPS}
            currentStep={currentStep}
          />
        </div>
        {loading ? (
          <div
            className={clsx(
              classes.centerContent,
              classes.pendingRequestContainer
            )}
          >
            <CircularProgress size={28} />
            <Typography className={classes.pendingRequestText}>
              Cargando informacion de la recarga...
            </Typography>
          </div>
        ) : (
          renderStepper()
        )}
      </div>
      <FooterStepper
        targetForm={FORM_ID}
        goBack={goBack}
        nextButtonText={nextButtonText}
        disabledNext={!canSubmit}
      />
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    paddingBottom: `calc(${
      theme.custom.footerHeight.stepper
    }px + ${theme.spacing(5)}px)`
  },
  centerContent: {
    margin: '0 auto'
  },
  contentContainer: {
    maxWidth: 960,
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
      padding: theme.spacing(2)
    }
  },
  stepperContainer: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(3)
    }
  },
  pendingRequestContainer: {
    paddingTop: theme.spacing(2),
    textAlign: 'center'
  },
  pendingRequestText: {
    marginTop: theme.spacing(1)
  }
}));

export default PrepaidMeter;
